import React from 'react';
import { FlaskConical } from 'lucide-react';

export function DemoBanner({ section }: { section: string }) {
  return (
    <div className="flex items-start gap-3 mb-5 px-4 py-3 bg-amber-50 border border-amber-200 rounded-xl text-sm text-amber-800">
      <FlaskConical size={16} className="shrink-0 mt-0.5 text-amber-500" />
      <span className="leading-snug">
        <span className="font-semibold">Раздел «{section}» в разработке.</span>{' '}
        Данные и интерфейс ниже — это пример того, как будет выглядеть раздел после запуска. Функциональность станет доступна в ближайшее время. 🚧
      </span>
    </div>
  );
}

